import { InjectionToken } from '@angular/core';

export const REVIEW_CLIENT_ROWS_PROJECT_IDS = new InjectionToken<readonly string[]>(
  'review.clientRowsProjectIds',
  {
    factory: () => [],
  },
);
